<template>
    <div class="tab-pane fade show active text-center" v-if="!is_data_ready">
        <span class="loader"></span>
    </div>
    <div class="tab-pane fade show active text-center" v-else-if="stats.length == 0">
        <p>No stats data found.</p>
        <!--      footer text-->
        <div class="note-text text-center py-10">
            <p>
                Our Cricket Analyst Covers the (Legends League Cricket 2022/23 Stats) Exclusively to Bring You the Authentic and Fastest Statistics Updates. Track and Stay Updated with Legends (League Cricket 2022/23 Stats of Teams), and Players with Planet Cricket.
            </p>
        </div>
    </div>
    <div class="tab-pane fade show active" v-else>
        <div class="table-responsive">
            <div class="match-table stats">
                <div class="thead">
                    <div class="table-row">
                        <div class="th">batting leaders</div>
                        <div class="th">score</div>
                    </div>
                </div>
                <div class="table-body">
                    <div class="tbody">
                        <div class="table-row" v-if="stats.leading_runs_scorer">
                            <div class="td">
                                <router-link :to="{ name: 'playerDetail.info', params:  { player: stats.leading_runs_scorer.player_slug} }">
                                    <span class="title d-none d-md-block"><u>{{ stats.leading_runs_scorer.player.name }}</u></span>
                                    <span class="title d-md-none"><u>{{ stats.leading_runs_scorer.player.short_name }}</u></span>
                                </router-link>
                                <span class="sub-title">Most Runs</span>
                            </div>
                            <div class="td">
                                <span class="title">{{ stats.leading_runs_scorer.stat_value }}</span>
                            </div>
                        </div>
                        <div class="table-row" v-if="stats.highest_inning_scorer">
                            <div class="td">
                                <router-link :to="{ name: 'playerDetail.info', params:  { player: stats.highest_inning_scorer.player_slug} }">
                                    <span class="title d-none d-md-block"><u>{{ stats.highest_inning_scorer.player.name }}</u></span>
                                    <span class="title d-md-none"><u>{{ stats.highest_inning_scorer.player.short_name }}</u></span>
                                </router-link>
                                <span class="sub-title">Most Runs in an Innings</span>
                            </div>
                            <div class="td">
                                <span class="title">{{ stats.highest_inning_scorer.stat_value }}</span>
                            </div>
                        </div>
                        <div class="table-row" v-if="stats.leading_sixes">
                            <div class="td">
                                <router-link :to="{ name: 'playerDetail.info', params:  { player: stats.leading_sixes.player_slug} }">
                                    <span class="title d-none d-md-block"><u>{{ stats.leading_sixes.player.name }}</u></span>
                                    <span class="title d-md-none"><u>{{ stats.leading_sixes.player.short_name }}</u></span>
                                </router-link>
                                <span class="sub-title">Most Sixes</span>
                            </div>
                            <div class="td">
                                <span class="title">{{ stats.leading_sixes.stat_value }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="table-responsive">
            <div class="match-table stats">
                <div class="thead">
                    <div class="table-row">
                        <div class="th">bowling leaders</div>
                        <div class="th">Stat</div>
                    </div>
                </div>
                <div class="table-body">
                    <div class="tbody">
                        <div class="table-row" v-if="stats.best_economy_bowler">
                            <div class="td">
                                <router-link :to="{ name: 'playerDetail.info', params:  { player: stats.best_economy_bowler.player_slug} }">
                                    <span class="title"><u>{{ stats.best_economy_bowler.player_name }}</u></span>
                                </router-link>
                                <span class="sub-title">Best Economy Bowler</span>
                            </div>
                            <div class="td">
                                <span class="title">{{ stats.best_economy_bowler.stat_value }}</span>
                            </div>
                        </div>
                        <div class="table-row" v-if="stats.best_bowling_figures">
                            <div class="td">
                                <router-link :to="{ name: 'playerDetail.info', params:  { player: stats.best_bowling_figures.player_slug} }">
                                    <span class="title"><u>{{ stats.best_bowling_figures.player_name }}</u></span>
                                </router-link>
                                <span class="sub-title">Best Bowling Stat</span>
                            </div>
                            <div class="td">
                                <span class="title">{{ stats.best_bowling_figures.stat_value }}</span>
                            </div>
                        </div>
                        <div class="table-row" v-if="stats.leading_wickets">
                            <div class="td">
                                <router-link :to="{ name: 'playerDetail.info', params:  { player: stats.leading_wickets.player_slug} }">
                                    <span class="title"><u>{{ stats.leading_wickets.player_name }}</u></span>
                                </router-link>
                                <span class="sub-title">Most Wickets</span>
                            </div>
                            <div class="td">
                                <span class="title">{{ stats.leading_wickets.stat_value }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--      footer text-->
        <div class="note-text text-center py-10">
            <p>
                Our Cricket Analyst Covers the (Legends League Cricket 2022/23 Stats) Exclusively to Bring You the Authentic and Fastest Statistics Updates. Track and Stay Updated with Legends (League Cricket 2022/23 Stats of Teams), and Players with Planet Cricket.
            </p>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    export default {
        name: 'tournamentStats',

        data() {
            return {
                stats: [],
                players: []
            }
        },
                jsonld() {

            if (isServer)
                return {
                    "@context": "http://schema.org",
                    "@graph": []
                }

            if (!this.is_data_ready)
                return
                let persons = []
               this.players.forEach((player) => {
                persons.push(
                        {
                            '@type': 'Person',
                            "name": player.name,
                            "alternateName": player.nick,
                            "address": player.birth_place,
                            "height": player.height,
                            "weight": player.weight,
                            "gender": player.gender,
                            "birthDate": moment(player.dob).format('YYYY-MM-DD HH:MM'),
                            "birthPlace": player.birth_place,
                            "description": "role "+player.role+ " "+ player.batting_style+" " + player.bowling_style+ " " + player.education,
                            "image": "https://planetcricket.com/public/images/logo1280x720.png"
                        }
                )
            });
                return {
                "@context": "http://schema.org",
                "@graph": persons
            }
        },
        metaInfo() {
            if (!Components['tournamentDetail'])
                return
            let title = `${Components['tournamentDetail'].tournament.name} Matches Stats, Score, Schedule, Point Table, Fixture - Planet Cricket`;
            let description = `Get All the Cricket standings, stats tables, matches updated, fixtures, results, of the ${Components['tournamentDetail'].tournament.name}, matches at Planet Cricket`;
            return {
                title: title,
                meta: this.$getMetaTags(title, description),
                link:[
                        {rel: 'canonical', href: 'https://planetcricket.com'+this.$route.path}],
            }

        },
        serverPrefetch() {
            if (this.$store.state.runSsr) {
                return this.main()
            }
        },
        mounted() {
            this.main()
        },

        methods: {
            main() {
                return this.$axios
                        .get(this.$TOURNAMENT_STATS_API.replace(':tournament', this.$route.params.tournament))
                        .then(response => {
                            this.is_data_ready = true
                            this.stats = response.data.result.stats || []
                            this.players = [this.stats.best_bowling_figures.player,this.stats.best_economy_bowler.player,
                                         this.stats.highest_inning_scorer.player,this.stats.leading_runs_scorer.player,
                                         this.stats.leading_sixes.player,this.stats.leading_wickets.player]
                        })
                        .catch(error => {
                            console.log(error);
                            this.is_data_ready = true
                        })
            },
        }
    }
</script>


